import React, { Component } from 'react'
import PropTypes from 'prop-types'
import uuid from 'uuid'
import { connect } from 'react-redux'
import { reduxForm, reset, getFormValues } from 'redux-form'

function decorator(config) {
  return ComposedComponent => {
    @reduxForm(
      {
        form: config.form,
        destroyOnUnmount: !config.persist,
        initialValues: config.initialValues
      },
      { reset }
    )
    @connect(state => ({
      bulkFormValues: getFormValues(config.form)(state)
    }))
    class BulkChange extends Component {
      static propTypes = {
        change: PropTypes.func,
        handleSubmit: PropTypes.func,
        initialize: PropTypes.func,
        destroy: PropTypes.func,
        options: PropTypes.object,
        router: PropTypes.object,
        routes: PropTypes.array,
        location: PropTypes.object,
        reset: PropTypes.func,
        route: PropTypes.object,
        values: PropTypes.object,
        bulkFormValues: PropTypes.object
      }

      componentDidMount() {
      }

      componentWillUnmount = () => {
        this.props.destroy(config.form)
      }

      key = uuid.v1()

      render() {
        const { handleSubmit, bulkFormValues } = this.props

        return (
          <form key={this.key} onSubmit={handleSubmit}>
            <ComposedComponent
              {...this.props}
              bulkFormValues={bulkFormValues || config.initialValues}
            />
          </form>
        )
      }
    }
    return BulkChange
  }
}

export default decorator
